/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import React from "react";
import { Redirect, Switch, Route } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import { Layout } from "../_metronic/layout";
import { Logout, AuthPage } from "./modules/Auth";
import BasePage from "./BasePage";
import ErrorsPage from "./modules/ErrorsExamples/ErrorsPage";
import { AccessDenied } from "./modules/Auth/pages/AccessDenied";
import {
  getDefaultBackofficePath,
  hasBackofficeAccess,
} from "./modules/Auth/access";

export function Routes() {
  const { user, isAuthenticated, isAuthorized, defaultPath } = useSelector(
    ({ auth }) => ({
      user: auth.user,
      isAuthenticated: auth.user != null,
      isAuthorized: hasBackofficeAccess(auth.user),
      defaultPath: getDefaultBackofficePath(auth.user),
    }),
    shallowEqual
  );

  return (
    <Switch>
      <Route exact path="/auth/registration/confirm">
        <AuthPage />
      </Route>
      {!isAuthenticated ? (
        /*Render auth page when user at `/auth` and not authorized.*/
        <Route>
          <AuthPage />
        </Route>
      ) : (
        /*Otherwise redirect to root page (`/`)*/
        <Redirect from="/auth" to={defaultPath} />
      )}

      <Route path="/error" component={ErrorsPage} />
      <Route path="/access-denied" component={AccessDenied} />
      <Route path="/logout" component={Logout} />

      {!isAuthenticated ? (
        /*Redirect to `/auth` when user is not authorized*/
        <Redirect to="/auth/login" />
      ) : !isAuthorized ? (
        <Redirect to="/access-denied" />
      ) : (
        <Layout>
          <BasePage user={user} />
        </Layout>
      )}
    </Switch>
  );
}
